import { Injectable } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root'
})
export class NetworkConnectionService {

  public hasNetworkConnection = true;
  public networkStatusListener: PluginListenerHandle | null = null;

  public async initialize() {
    const status = await Network.getStatus();
    console.log(`[Network] ${status.connected ? 'Connected' : 'Disconnected'} (${status.connectionType})`);
    this.hasNetworkConnection = status.connected;

    this.networkStatusListener = await Network.addListener('networkStatusChange', async status => {
      console.log(`[Network] ${status.connected ? 'Connected' : 'Disconnected'} (${status.connectionType})`);
      this.hasNetworkConnection = status.connected;
    });
  }

}
